import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-text-repeat-admin-config',
  templateUrl: './text-repeat-admin-config.component.html',
  styleUrls: ['./text-repeat-admin-config.component.scss']
})
export class AtwTextRepeatAdminConfig extends AtwUpdateDbComponent {
  /** object đang chọn */
  @Input() objectChoosing: any;
  /** Thiết bị hiện tại (desktop, tablet_portrait, tablet_landscape, mobile_portrait, mobile_landscape) */
  @Input() device: any;
  /** Dữ liệu class của thiết bị hiện tại */
  @Input() class: any;
  /** Dữ liệu config của thiết bị hiện tại */
  @Input() config: any;
  /** Dữ liệu staticdata */
  @Input() staticdata: any;
  /** Dữ liệu blocks_of_page */
  @Input() blocks_of_page: any;
  /** Loại trang (page, admin, ...) */
  @Input() type: any;

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'Cấu hình chi tiết Hiệu ứng',
      index: 1,
    },
    {
      title: 'cau_hinh_bo_goc',
      index: 2,
    }
  ];

  effect_hover = [];
  effect_hover_data: any = {};
  text_style: any = [
    {
      title: 'tieu_de_1',
      fontSize: '68px',
      name: 'h1',
      font: 21
    },
    {
      title: 'tieu_de_2',
      fontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'tieu_de_3',
      fontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'tieu_de_4',
      fontSize: '26px',
      name: 'h4',
      font: 17
    },
    {
      title: 'tieu_de_5',
      fontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'tieu_de_6',
      fontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'van_ban',
      fontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_quan_trong',
      fontSize: '18px',
      name: 'strong',
      font: 14
    },
    {
      title: 'van_ban_nho',
      fontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'trich_dan',
      fontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  /** Danh sách giải thích loại văn bản tương ứng SEO */
  seoTextTypes: any = [
    { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
    { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
    { tag: 'van_ban', explain: 'dung_cho_van_ban' },
    { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
  ];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'mac_dinh',
      img: 'src/assets/root/icon/user/gdDefault.png',
      deg: '180deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'tu_trai_sang_phai',
      img: 'src/assets/root/icon/user/gdToRight.png',
      deg: '90deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'tu_phai_sang_trai',
      img: 'src/assets/root/icon/user/gdToLeft.png',
      deg: '270deg'
    },
  ];
  public listCursor = [
    { label: 'Mặc định', value: 'default' },
    { label: 'Bàn tay', value: 'pointer' },
    { label: 'Chép', value: 'copy' },
    { label: 'Di chuyển', value: 'move' },
    { label: 'Văn bản chọn', value: 'text' },
    { label: 'N-Resize', value: 'n-resize' },
    { label: 'NE-Resize', value: 'ne-resize' },
    { label: 'E-Resize', value: 'e-resize' },
    { label: 'SE-Resize', value: 'se-resize' },
    { label: 'S-Resize', value: 's-resize' },
    { label: 'SW-Resize', value: 'sw-resize' },
    { label: 'W-Resize', value: 'w-resize' },
    { label: 'NW-Resize', value: 'nw-resize' },
    { label: 'N-Resize EW', value: 'ns-resize' },
    { label: 'E-Resize NS', value: 'ew-resize' },
    { label: 'All-Scroll', value: 'all-scroll' },
    { label: 'Not-Allowed', value: 'not-allowed' },
    { label: 'Progress', value: 'progress' },
    { label: 'Wait', value: 'wait' },
    { label: 'Help', value: 'help' },
    { label: 'Zoom-In', value: 'zoom-in' },
    { label: 'Zoom-Out', value: 'zoom-out' },
    { label: 'Grab', value: 'grab' },
    { label: 'Grabbing', value: 'grabbing' },
  ];

  id_subproject: any = "";

  configMode: 'basic' | 'advanced' = 'basic';

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/text.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }


  /**
   * Cập nhật transform
   */
  handleSetTextRotate() {
    this.class['text__content']['transform'] = `rotate(${this.config['transform']['rotate']}deg)`;
  }


  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.class['text__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text__content']['border-left-width'] = '10px';
        this.class['text__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text__content']['border-left-width'] = '0';
        this.class['text__content']['padding-left'] = '0';
    }

    this.handleSetCurveText();

    this.updateObject();
  }

  /**
   * Cập nhật Kiểu danh sách đầu dòng, đánh số
   */
  handleListStyle(style: string) {
    if (`${style} inside none` === this.class['text__content--list-style']['list-style']) {
      style = "none";
      this.config['text_type'] = 'p';
    }
    else {
      this.config['text_type'] = 'ul';
    }

    switch (style) {
      case 'disc':
      case 'decimal':
      case 'upper-alpha':
      case 'upper-roman':
        this.class['text__content']['flex-direction'] = 'column';
        this.class['text__content--list-style']['list-style'] = `${style} inside none`;
        break;
      default:
        this.class['text__content']['flex-direction'] = 'row';
        this.class['text__content--list-style']['list-style'] = 'none';
    }

    this.updateObject();
  }



  /**
   * Xử lý kiểu Uốn cong
   */
  handleSetCurveText() {
    var radius = this.config['curve']['radius'] * 1;

    this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
    this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
    this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    // this.class['text__curve-item']['height'] = radius + 'px';

    this.class['text__curve']['height'] = (radius * 2) + 'px';
    this.class['text__curve']['width'] = (radius * 2) + 'px';
  }

  // GRADIENT
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image']['gradient_check']) {
      this.class['text__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
      this.class['text__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text__content']['background-image'] = 'none';
      this.class['text__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text__content']['-webkit-background-clip'] = 'unset';
    }

    // gradient cho kiểu uốn cong
    if (this.config['curve']['isCurve']) {
      this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
      this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
      this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    }

    this.updateClass();
    this.updateConfig();
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient').click();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['background_image_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['background_image_opacity'] = e.target.value;
    const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`
    })
    this.config['background-image']['background_image_arr_gradient'] = newArr;

    this.handleSetGradientText();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['background_image_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  // ANIMATION
  customize = []

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then(
        (bool) => {

        },
        (error) => {
          console.error(error);
        }
      );
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };


  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    
    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.styles_field[0]);
    }
  }

}
